import React, { useEffect, useState } from 'react';
import './ContactUs.css';
import { TopNav, SiteFooter } from './SiteChrome';
import { buildWhatsAppLink, contactEmail } from './siteContent';
import { useLanguage } from './LanguageContext';

const ContactUs = () => {
  const { content } = useLanguage();
  const [statusMessage, setStatusMessage] = useState('');

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('revealed');
          }
        });
      },
      { threshold: 0.1 }
    );

    document.querySelectorAll('.reveal').forEach((el) => observer.observe(el));
    return () => observer.disconnect();
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    const formData = new FormData(e.currentTarget);
    const fullName = formData.get('name')?.toString().trim() || '';
    const email = formData.get('email')?.toString().trim() || '';
    const message = formData.get('message')?.toString().trim() || '';

    const subject = encodeURIComponent(`Pesan baru dari ${fullName || 'website DIGITARA'}`);
    const body = encodeURIComponent([
      `Nama: ${fullName}`,
      `Email: ${email}`,
      '',
      message,
    ].join('\n'));

    window.location.href = `mailto:${contactEmail}?subject=${subject}&body=${body}`;
    setStatusMessage(content.contact.modalText);
  };

  return (
    <div className="contact-page">
      {/* Cosmic Dust Overlay */}
      <div className="contact-cosmic-dust"></div>

      <TopNav />

      {/* Main Content */}
      <main className="contact-main">
        <div className="contact-wrapper">
          <header className="contact-header animate-fade-up">
            <h1 className="contact-title">{content.contact.title}</h1>
            <p className="contact-subtitle">{content.contact.subtitle}</p>
          </header>

          <form className="glass-panel reveal delay-100" onSubmit={handleSubmit}>
            {/* Subtle internal glow */}
            <div className="form-glow"></div>

            <div className="form-content">
              <div className="form-group">
                <label className="form-label" htmlFor="name">{content.contact.name}</label>
                <input 
                  className="form-input" 
                  id="name" 
                  name="name" 
                  placeholder={content.contact.namePlaceholder} 
                  type="text" 
                  required
                />
              </div>

              <div className="form-group">
                <label className="form-label" htmlFor="email">{content.contact.email}</label>
                <input 
                  className="form-input" 
                  id="email" 
                  name="email" 
                  placeholder={content.contact.emailPlaceholder} 
                  type="email" 
                  required
                />
              </div>

              <div className="form-group">
                <label className="form-label" htmlFor="message">{content.contact.message}</label>
                <textarea 
                  className="form-textarea" 
                  id="message" 
                  name="message" 
                  placeholder={content.contact.messagePlaceholder} 
                  rows="3"
                  required
                ></textarea>
              </div>
            </div>

            <div className="contact-actions reveal delay-200">
              <button className="submit-btn" type="submit">
                {content.contact.submit}
              </button>
              <a className="whatsapp-btn" href={buildWhatsAppLink('Halo DIGITARA, saya ingin berkonsultasi.')} target="_blank" rel="noreferrer">
                <span aria-hidden="true" className="material-symbols-outlined">chat</span>
                {content.contact.whatsapp}
              </a>
            </div>

            <p className="contact-note reveal delay-300">{content.contact.note}</p>

            {statusMessage ? <div className="contact-status reveal delay-400">{statusMessage}</div> : null}
          </form>
        </div>
      </main>

      <SiteFooter />
    </div>
  );
};

export default ContactUs;
